import loadable from '@loadable/component';
const path = './src/models/index.ts';
const deprecated = {
  reason: 'Используйте виджет CardCarouselV2',
  migration: './migration.md'
};
export const manifest = {
  CardCarousel: {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CardCarouselDeprecated";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CardCarouselDeprecated" */
          './desktop-deprecated'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./desktop-deprecated");
            }

            return eval('require.resolve')("./desktop-deprecated");
          }

        }, {
          resolveComponent: mod => mod.CardCarouselDeprecated
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "CardCarouselMobileDeprecated";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "CardCarouselMobileDeprecated" */
          './mobile-deprecated'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./mobile-deprecated");
            }

            return eval('require.resolve')("./mobile-deprecated");
          }

        }, {
          resolveComponent: mod => mod.CardCarouselMobileDeprecated
        })
      }
    }
  }
};